// extracted by mini-css-extract-plugin
export default {"notVisibleSrOnlyText":"notVisibleSrOnlyText--AsmMv"};